import React from 'react';
import AmountWithIvaCell from '../../components/cells/AmountWithIvaCell';
import CompanyCell from '../../components/cells/CompanyCell';
import { getLazyFolioColumn } from '../../constants/document-finance-lazy-folio-columns';
import TransferConditionsCell from '../../components/cells/TransferConditionsCell';
import DateCell from '../../components/cells/DateCell';
import DateWithDaysDiffCell from '../../components/dataGridCells/DateWithDaysDiffCell';
import InvoiceStatusCell from './components/InvoiceStatusCell';
import ViewDetailCell from './components/ViewDetailCell';

const getOperationsColumns = (options = {}) => {
  const { isMobile = false, showWarnings = true } = options;

  return [
    {
      field: 'operationId',
      headerName: 'N° Operación',
      sortable: false,
      disableColumnMenu: true,
      width: isMobile ? 70 : 120,
      valueGetter: ({ row }) => row.operation?.id || '-',
    },
    {
      field: 'dateOperation',
      headerName: 'Operación',
      disableColumnMenu: true,
      width: isMobile ? 85 : 130,
      renderCell: ({ row }) => <DateWithDaysDiffCell date={row.dateOperation} useIcon={false} />,
    },
    getLazyFolioColumn({
      field: 'lazy_folio',
      headerName: 'Folio',
      width: isMobile ? 65 : 100,
    }),
    {
      field: 'receiver_sortable',
      headerName: 'Receptor',
      disableColumnMenu: true,
      minWidth: 90,
      flex: 1,
      renderCell: ({ row }) => <CompanyCell company={row.receiver} />,
    },
    {
      field: 'amountWithIva',
      headerName: 'Monto factura',
      disableColumnMenu: true,
      width: isMobile ? 90 : 126,
      renderCell: ({ row }) => <AmountWithIvaCell row={row} />,
    },
    {
      field: 'operationDateToPay',
      headerName: 'Vencimiento',
      sortable: false,
      disableColumnMenu: true,
      width: 140,
      renderCell: ({ row }) => (
        <DateWithDaysDiffCell date={row.dateToPay} status={row.status} useColors />
      ),
    },
    {
      field: 'collectionDate',
      headerName: 'Recaudación',
      sortable: false,
      disableColumnMenu: true,
      width: 140,
      renderCell: ({ row }) => <DateCell date={row.collectionDate} />,
    },
    {
      field: 'offer_pendingDocuments',
      headerName: 'Condiciones de giro',
      type: 'string',
      align: 'left',
      sortable: false,
      disableColumnMenu: true,
      width: 170,
      renderCell: ({ row }) => <TransferConditionsCell invoice={row} type="Operations" />,
    },
    {
      field: 'operationStatus',
      headerName: 'Estado',
      sortable: false,
      disableColumnMenu: true,
      width: isMobile ? 150 : 170,
      renderCell: ({ row }) => <InvoiceStatusCell invoice={row} showWarning={showWarnings} />,
    },
    {
      field: 'viewDetail',
      headerName: 'Detalle',
      type: 'actions',
      sortable: false,
      disableColumnMenu: true,
      width: 160,
      renderCell: ({ row }) => <ViewDetailCell invoiceId={row.id} />,
    },
  ];
};

export default getOperationsColumns;
